import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const searchTypes = ["Cogeneration Plant", "Supplier", "Classified"];

function DynamicSearch() {
  const [selectedType, setSelectedType] = useState("Cogeneration Plant");
  const [query, setQuery] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchKeywords = async () => {
      try {
        const res = await axios.get("https://backend-zkgn.onrender.com/api/search-keywords", {
          params: { type: selectedType },
        });
        setKeywords(res.data.keywords || []);
      } catch (err) {
        console.error(err);
        setKeywords([]);
      }
    };
    fetchKeywords();
    setQuery("");
    setSuggestions([]);
  }, [selectedType]);

  useEffect(() => {
    if (!query) return setSuggestions([]);
    const timeout = setTimeout(() => {
      const filtered = keywords.filter((k) =>
        k?.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filtered);
    }, 200);
    return () => clearTimeout(timeout);
  }, [query, keywords]);

  const handleInputChange = (e) => setQuery(e.target.value);

  const handleSuggestionClick = (item) => {
    navigate(`/search?type=${encodeURIComponent(selectedType)}&q=${encodeURIComponent(item)}`);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    navigate(`/search?type=${encodeURIComponent(selectedType)}&q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="container-fluid mt-0 my-3 mt-lg-0 custom-navbar">
      <div className="row">
        <div className="col-lg-12">
          <div className="search-bar position-relative p-3">
            <form className="row g-3 align-items-center" onSubmit={handleSearch}>
              
              {/* Dropdown */}
              <div className="col-lg-3 col-md-4">
                <select
                  className="form-select"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  {searchTypes.map((type, idx) => (
                    <option key={idx} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              {/* Input + Suggestions */}
              <div className="col-lg-7 col-md-5 position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Search ${selectedType.toLowerCase()}...`}
                  value={query}
                  onChange={handleInputChange}
                />
                {suggestions.length > 0 && (
                  <div className="autocomplete-suggestions list-group position-absolute w-100 z-3">
                    {suggestions.map((item, index) => (
                      <button
                        type="button"
                        key={index}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleSuggestionClick(item)}
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Search button */}
              <div className="col-lg-2 col-md-3">
                <button type="submit" className="btn btn-outline-light w-100">
                  <i className="fa fa-search"></i>
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DynamicSearch;
